/**
* @license Apache-2.0
*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Compute the variance of a strided array ignoring `NaN` values and using a one-pass textbook algorithm.
*
* @module @stdlib/stats/strided/nanvariancetk
*
* @example
* import nanvariancetk from '@stdlib/stats/strided/nanvariancetk';
*
* var x = [ 1.0, -2.0, NaN, 2.0 ];
*
* var v = nanvariancetk( x.length, 1, x, 1 );
* // returns ~4.3333
*
* @example
* import nanvariancetk from '@stdlib/stats/strided/nanvariancetk';
*
* var x = [ 2.0, 1.0, 2.0, -2.0, -2.0, 2.0, 3.0, 4.0, NaN, NaN ];
*
* var v = nanvariancetk.ndarray( 5, 1, x, 2, 1 );
* // returns 6.25
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-nonenumerable-read-only-property';
import main from './main.js';
import ndarray from './ndarray.js';


// MAIN //

setReadOnly( main, 'ndarray', ndarray );


// EXPORTS //

export default main;
